import * as zExt from "@redotech/rpc/ext";
import { shopperAgentStrategyIdFormat } from "@redotech/shopper-agent-strategy-id";
import * as z from "zod";

export const updateShopperAgentStrategy = {
  name: "updateShopperAgentStrategy" as const,
  input: z.object({
    strategyId: shopperAgentStrategyIdFormat.schema,
    /** Wins over the agent fields when both are sent. */
    guidance: z.string().optional(),
    goalGuidance: z.string().optional(),
    outreachGuidance: z.string().optional(),
    mongoDiscountId: zExt.objectId().nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
